import { useEffect, useState } from "react";

/**
 * Tracks whether the cookie consent banner is currently visible.
 * The CookieConsent component sets `data-cookie-banner="visible"` on <body>
 * while the banner is shown so other floating UI can yield space on mobile.
 */
export function useCookieBannerVisible() {
  const [visible, setVisible] = useState(
    typeof document !== "undefined" &&
      document.body.dataset.cookieBanner === "visible"
  );

  useEffect(() => {
    const update = () => {
      setVisible(document.body.dataset.cookieBanner === "visible");
    };
    update();
    const observer = new MutationObserver(update);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-cookie-banner"],
    });
    return () => observer.disconnect();
  }, []);

  return visible;
}
